import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import EquipmentStore from "../../../stores/EquipmentStore"
import EquipmentHistoryTable from "./EquipmentHistoryTable"
import { IEquipmentMetaData } from "../../../models"
interface IProps {

}
interface IState {
    history: IEquipmentMetaData[]
}

export default class EquipmentHistory extends React.PureComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            history: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.changeSelectedEquipment()
        EquipmentStore.on("equipment_change", this.changeSelectedEquipment)
    }

    componentWillUnmount() {
        EquipmentStore.removeListener("equipment_change", this.changeSelectedEquipment)
    }

    changeSelectedEquipment() {
        const history = EquipmentStore.getSelectedEquipment().History
        this.setState({ history })
    }

    render() {
        return (
            <div className="Users" style={{ padding: "40px 30px 30px 30px" }}>
                <div style={{ fontSize: 25, fontWeight: "bold" }}>{strings.History}</div>
                <EquipmentHistoryTable history={this.state.history ? this.state.history : []} />
            </div>
        )
    }
}
